// extracted by mini-css-extract-plugin
export var askAiIcon = "_m7-9";
export var container = "_m7-0";
export var groupSeparator = "_m7-a";
export var highlight = "_m7-4";
export var resultIcon = "_m7-5";
export var resultItem = "_m7-7";
export var resultSubtitle = "_m7-3";
export var resultTitle = "_m7-2";
export var resultsList = "_m7-1";
export var searchGroup = "_m7-6";
export var selected = "_m7-8";